<template>
  <div class="app__trow">
    <div class="app__tdata avatar">
      <img :src="rowData.avatarUrl" alt class="avatar-img" @error="handleImgError" />
    </div>

    <!-- TOTEM FIELDS -->
    <div class="app__tdata small" v-if="rowData.totem_name">{{rowData.totem_name}}</div>
    <div class="app__tdata small bold" v-if="rowData.qnt">{{rowData.qnt}}</div>
    <div
      class="app__tdata small bold status-data"
      :class="rowData.status=='Online'?'online':'offline'"
      v-if="rowData.status"
    >
      <i class="fas fa-circle"></i>
      &nbsp;
      <span>{{rowData.status}}</span>
    </div>
    <!-- DEPARTMETNS FIELDS -->
    <div class="app__tdata" v-if="rowData.name">{{rowData.name}}</div>
    <div class="app__tdata" v-if="rowData.login">{{rowData.login}}</div>
    <div class="app__tdata" v-if="rowData.email">{{rowData.email}}</div>
    <div class="app__tdata" v-if="rowData.setor">{{rowData.setor}}</div>
    <!-- COMPANY PANEL FIELDS -->
    <div class="app__tdata bold" v-if="rowData.q_logo">
      <div class="line-right">
        <div class="app__tdata-img">
          <img :src="rowData.q_logo" alt />
        </div>
      </div>
    </div>
    <div class="app__tdata bold" v-if="rowData.q_dep">
      <a @click.prevent="$emit('open-company',rowData._id)" href="#">{{rowData.company_name}}</a>
    </div>
    <div class="app__tdata bold" v-if="rowData.q_dep">{{rowData.q_dep}}</div>
    <div class="app__tdata bold" v-if="rowData.q_totem">{{rowData.q_totem}}</div>
    <div class="app__tdata bold" v-if="rowData.q_members">{{rowData.q_members}}</div>
    <!-- ACTION BTN -->
    <div class="app__tdata action" v-if="rowData.action">
      <button
        class="sgnup__btn is-relative"
        @click="active=!active"
        @mouseleave="active=false"
        :style="active?'cursor:unset':''"
      >
        <i class="fas fa-ellipsis-h"></i>
        <div class="app__taction-tab"  v-show="active">
          <div class="app__taction-head">Opções</div>
          <span class="app__taction-btn" v-show="rowData.ativo" @click="$emit('edit-item',rowData._id)">Editar</span>
          <span class="app__taction-btn" v-show="rowData.ativo" @click="$emit('disable-item',rowData._id)">Excluir</span> 
          <span class="app__taction-btn" v-show="!rowData.ativo" @click="$emit('activate-item',rowData._id)">Reativar</span>
        </div>
      </button>
    </div>
  </div>
</template>
<script>
import config from "../config";
import defaultImg from '../../public/img/unknown-icon.jpg'
export default {
  props: {
    rowData: null
  },
  data() {
    return {
      active: false,
      conf: config,
      fallbackImg: defaultImg,
    };
  },
  mounted() {
    console.log(this.rowData);
  },
  methods: {
    handleImgError(event) {
      event.target.src = this.fallbackImg;
    }
  }
};
</script>

<style scoped>
.app__tdata .avatar{
  width: 40px;
  height: 40px;
  max-width: 40px;
  max-height: 40px;
  /* position: relative */

}

.avatar-img{
  /* width: 100%;
  height: 100%; */
  width: 40px;
  height: 40px;
  max-width: 40px;
  max-height: 40px;
  object-fit: cover;
  /* border-radius: 100%; */
}
</style>

